import React, { useEffect } from "react";
import { Admin } from "react-admin";
import { ThemeProvider } from "@material-ui/core/styles";
import authProvider from "./components/authProvider";
import dataProvider from "./dataProvider";
import customRoutes from "./customRoutes";
import axios from "axios";
import LogoutButton from "./components/logoutButton";
import LoginPage from "./components/login-page";
import ForgotPassword from "./components/forgotPassword";
import customTheme from "./customTheme";
import CustomLayout from "./Layout/customLayout";
import NotFound from "./components/notFound";
import getResourcesWithPermissions from "./ResourcesWithPermissions";
import dashboard from "./components/dashboard";

const App = () => {
  const access_token = sessionStorage.getItem("access_token");

  useEffect(() => {
    if (access_token) {
      axios.defaults.headers.common = {
        Authorization: "Bearer " + access_token,
        Accept: "application/json",
      };
    }
  }, [access_token]);

  return (
    <ThemeProvider theme={customTheme}>
      <Admin
        catchAll={NotFound}
        theme={customTheme}
        forgotPassword={ForgotPassword}
        dashboard={dashboard}
        authProvider={authProvider}
        dataProvider={dataProvider}
        customRoutes={customRoutes}
        loginPage={LoginPage}
        logoutButton={LogoutButton}
        layout={CustomLayout}
      >
        {(permissions) => getResourcesWithPermissions(permissions)}
      </Admin>
    </ThemeProvider>
  );
};

export default App;
